import { render, staticRenderFns } from "./SalesConnectAccount.vue?vue&type=template&id=0b5cd856&"
import script from "./SalesConnectAccount.vue?vue&type=script&lang=js&"
export * from "./SalesConnectAccount.vue?vue&type=script&lang=js&"
import style0 from "./SalesConnectAccount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports